// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { VMessageTemplateContext } from '../../index.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VMessageTemplateContext {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VMessageTemplateContext;
}
export { assert as assertMessageTemplateContext };


export function is(value: any): value is VMessageTemplateContext {
	const result = validate(value);
    return result.success;
}
export { is as isMessageTemplateContext };


import type { ValidationResult } from '@atlassian/vindicated';
export function validate(value: any): ValidationResult<VMessageTemplateContext> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'MessageTemplateContext', value: value });
    } else {
			if ('scopes' in value && value['scopes'] !== undefined) {
				if (!Array.isArray(value["scopes"])) errors.push({ path: 'value["scopes"]', expected: 'array', value: value["scopes"] });if (Array.isArray(value["scopes"])) { value["scopes"].forEach((element, index) => { 
	if (typeof element !== 'object' || element === null || Array.isArray(element)) {
        errors.push({ path: 'element', expected: 'object', value: element });
    } else {
			if (!('name' in element)) {
				errors.push({ path: 'element["name"]', expected: 'string', value: undefined });
			} else {
				if (typeof element["name"] !== 'string') errors.push({ path: 'element["name"]', expected: 'string', value: element["name"] });
			}
    } }); }
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateMessageTemplateContext };
